import { useEffect, useRef, useState } from "react";
import { ReactComponent as IconSearch } from "../../../layout/others/icon_search.svg";
import { ReactComponent as IconClear } from "../../../layout/others/icon_clear_reverse.svg";
import PropTypes from "prop-types";
import "./DropDownMultiCheck.css";
import { useTranslation } from "react-i18next";

export function DropDownMultiCheckCtrl(dataList, isIdStringType) {
  this.dataList = dataList;
  this.isIdStringType = isIdStringType;

  this.onDropDownCheckBoxCheck = (target, selected) => {
    let item = dataList.filter(
      (item) =>
        item.id === (isIdStringType ? target.value : Number(target.value))
    )[0];
    if (target.checked) {
      if (selected.map((x) => x.id).indexOf(item.id) === -1)
        selected.push(item);
    } else
      selected.splice(
        selected
          .map((x) => x.id)
          .indexOf(isIdStringType ? target.value : Number(target.value)),
        1
      );
    return selected;
  };
}

export function DropDownMultiCheck({
  dataList,
  selecteds,
  setSelecteds,
  onRemoveSelected,
  isIdStringType,
  autoCompleteMode,
  hideSelected
}) {
  const [dropDownShow, setDropDownShow] = useState(false);
  const [dataListCopy, setDataListCopy] = useState([]);
  const [searcFilterValue, setSearchFilterValue] = useState("");
  const ref = useRef();
  const containerRef = useRef();
  const { t } = useTranslation();
  let ctrl = new DropDownMultiCheckCtrl(dataList, isIdStringType);

  function onSearchIconClick() {
    if (dropDownShow) {
      setDropDownShow(false);
    } else {
      setSearchFilterValue("");
      setDropDownShow(true);
      setTimeout(() => {
        ref.current && ref.current.focus();
        if (!autoCompleteMode) setDataListCopy(dataList);
        else setDataListCopy([]);
      }, 2);
    }
  }

  function onDropDownCheckBoxCheck({ target }) {
    let _selected = [...selecteds];
    setSelecteds(ctrl.onDropDownCheckBoxCheck(target, _selected));
  }

  function onRemoveItemFromSelectList(id) {
    let _selected = [...selecteds];
    _selected.splice(_selected.map((x) => x.id).indexOf(id), 1);
    setSelecteds(_selected);
    if (onRemoveSelected) onRemoveSelected(id);
  }

  function onSearchForFilter({ target }) {
    setSearchFilterValue(target.value);
    let filtered = [];
    if (target.value.length < 2) {
      if (!autoCompleteMode) {
        setDataListCopy(dataList);
      }
    } else {
      setDropDownShow(true);

      let patern = new RegExp(
        target.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "i"
      );
      for (let item of dataList) {
        if (patern.test(item.description)) filtered.push(item);
      }
      setDataListCopy(filtered);
    }
  }

  function ondropDownItemLabelClick(itemId) {
    let _selected = [...selecteds];
    let item = dataList.filter(
      (item) => item.id === (isIdStringType ? itemId : Number(itemId))
    )[0];

    if (_selected.map((x) => x.id).indexOf(item.id) === -1)
      _selected.push(item);
    else
      _selected.splice(
        _selected
          .map((x) => x.id)
          .indexOf(isIdStringType ? itemId : Number(itemId)),
        1
      );

    setSelecteds(_selected);
  }

  useEffect(() => {
    function handleClickOutside({ target }) {
      if (containerRef.current && !containerRef.current.contains(target)) {
        setDropDownShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const truncate = (input) =>
    input.length > 30 ? `${input.substring(0, 30)}...` : input;
  return (
    <div className="dropdown">
      <ul
        className="list-inline  form-control mb-0"
        onClick={() => {
          onSearchIconClick();
        }}
      >
        <li className="list-inline-item">
          <IconSearch title={t("search")} />
        </li>
        {/* {selecteds &&
          selecteds.map((sel, index) => (
            <li className="list-inline-item m-2" key={index}>
              <span className="rounded-pill bg-ligth p-2  text-white bg-dark fontsize-legend">
                {t(sel.description)}{" "}
                <IconClear
                  title={t("Delete")}
                  onClick={() => onRemoveItemFromSelectList(sel.id)}
                />
              </span>
            </li>
          ))} */}
        {selecteds && hideSelected
          ? truncate(selecteds.map((sel, index) => sel.description).join(", "))
          : selecteds.map((sel, index) => (
              <li className="list-inline-item m-2" key={index}>
                <span className="rounded-pill bg-ligth p-2  text-white bg-dark">
                  {t(sel.description)}{" "}
                  <IconClear
                    title={t("Delete")}
                    onClick={() => onRemoveItemFromSelectList(sel.id)}
                  />
                </span>
              </li>
            ))}
      </ul>
      <ul
        className={`dropdown-menu  p-2 ${dropDownShow && "show"} mt-2 `}
        ref={containerRef}
      >
        <li>
          <div className="mb-3">
            <input
              ref={ref}
              autoFocus={true}
              className="form-control"
              onChange={onSearchForFilter}
              placeholder={t("Search...")}
              value={searcFilterValue}
            ></input>
          </div>
        </li>
        {dataListCopy.map((item, index) => (
          <li key={index} onClick={() => ondropDownItemLabelClick(item.id)}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.id}
                checked={
                  selecteds &&
                  selecteds.map((sel) => sel.id).indexOf(item.id) > -1
                }
                onChange={onDropDownCheckBoxCheck}
              />
              <label
                className="form-check-label fontsize-legend"
                htmlFor="flexCheckDefault"
              >
                {t(item.description)}
              </label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

DropDownMultiCheck.propTypes = {
  dataList: PropTypes.array.isRequired,
  selecteds: PropTypes.array.isRequired,
  setSelecteds: PropTypes.func.isRequired,
  isIdStringType: PropTypes.bool,
  onRemoveSelected: PropTypes.func
};
